var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 433.011,
    height: 227.78,
    viewBox: "0 0 433.011 227.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.628,
    cy: 0.8,
    r: 1.248,
    gradientTransform: "translate(-0.009 0.511) scale(0.526 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aeb2d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#aeb2d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#484c89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484c89"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "php",
    transform: "translate(-729.4 -2376.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3440",
    transform: "translate(729.4 2376.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3448"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3450"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3462",
    d: "M14.4-270.409c0,62.9,96.935,113.89,216.505,113.89h0c119.57,0,216.506-50.991,216.506-113.89h0c0-62.9-96.936-113.89-216.506-113.89h0C111.335-384.3,14.4-333.307,14.4-270.409",
    transform: "translate(-14.4 384.299)",
    fill: "url(#radial-gradient)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "g3464",
    transform: "translate(737.857 2385.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3472"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3474",
    d: "M-124.052-125.734C-9.152-125.734,84-172.939,84-231.168S-9.152-336.6-124.052-336.6-332.1-289.4-332.1-231.168s93.148,105.434,208.048,105.434",
    transform: "translate(332.1 336.603)",
    fill: "#777bb3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g3476",
    transform: "translate(792.948 2405.191)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g3484",
    transform: "translate(2.349 32.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3486",
    d: "M-30.846-39.222c9.448,0,16.5-1.742,20.964-5.177,4.415-3.4,7.464-9.289,9.063-17.5C.671-69.581.1-74.943-2.506-77.837c-2.668-2.955-8.436-4.454-17.144-4.454h-15.1l-8.37,43.069ZM-80.229,13.832a2.346,2.346,0,0,1-1.812-.855,2.348,2.348,0,0,1-.493-1.942L-60.352-103.1a2.35,2.35,0,0,1,2.306-1.9h47.81C4.79-105,15.974-100.92,23-92.872c7.067,8.09,9.25,19.4,6.486,33.61A53.647,53.647,0,0,1,23.742-43.28a53.512,53.512,0,0,1-10.58,13.257A46.415,46.415,0,0,1-4.251-19.589c-6.267,2.041-14.315,3.077-23.921,3.077H-47.532L-53.06,11.931a2.349,2.349,0,0,1-2.305,1.9Z",
    transform: "translate(82.578 105)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3488",
    transform: "translate(0 30.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3490",
    d: "M-31.074-16.342h13.162c10.51,0,14.16,2.306,15.4,3.68C-.454-10.38-.065-5.569-1.388,1.251-2.874,8.886-5.629,14.3-9.577,17.339c-4.042,3.112-10.614,4.689-19.531,4.689h-9.424ZM-8.5-43.75H-56.308a4.7,4.7,0,0,0-4.612,3.8L-83.1,74.186a4.7,4.7,0,0,0,.986,3.885,4.7,4.7,0,0,0,3.626,1.709h24.863a4.7,4.7,0,0,0,4.612-3.8l5.159-26.542h17.423c9.853,0,18.147-1.074,24.65-3.193A48.761,48.761,0,0,0,16.5,35.293,55.884,55.884,0,0,0,27.53,21.466a55.991,55.991,0,0,0,6-16.681c2.909-14.96.546-26.939-7.023-35.6C19.015-39.4,7.236-43.75-8.5-43.75M-44.232,26.727h15.124q15.036,0,22.4-5.665T3.224,2.145Q5.692-10.578.976-15.81t-18.889-5.231H-34.947l-9.284,47.768M-8.5-39.052q21.574,0,31.47,11.324T28.922,3.889a51.1,51.1,0,0,1-5.493,15.285A50.971,50.971,0,0,1,13.31,31.847,43.914,43.914,0,0,1-3.239,41.776q-9.1,2.966-23.2,2.962h-21.3l-5.9,30.344H-78.491L-56.308-39.052H-8.5",
    transform: "translate(83.189 43.75)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3492",
    transform: "translate(108.19 2.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3494",
    d: "M-37.7-70.856a2.345,2.345,0,0,1-1.812-.855,2.345,2.345,0,0,1-.494-1.942l9.813-50.5c.933-4.8.7-8.25-.648-9.706-.827-.89-3.311-2.384-10.655-2.384H-59.278L-71.615-72.757a2.35,2.35,0,0,1-2.306,1.9H-98.588a2.348,2.348,0,0,1-1.813-.855,2.348,2.348,0,0,1-.493-1.942l22.183-114.134a2.35,2.35,0,0,1,2.306-1.9h24.667a2.35,2.35,0,0,1,1.813.854,2.349,2.349,0,0,1,.493,1.943l-5.353,27.547h19.124c14.569,0,24.448,2.568,30.2,7.853,5.865,5.391,7.7,14.01,5.44,25.621L-10.339-72.757a2.349,2.349,0,0,1-2.306,1.9Z",
    transform: "translate(100.938 189.688)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3496",
    transform: "translate(105.841)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3498",
    d: "M-30.737,0H-55.4a4.7,4.7,0,0,0-4.612,3.8L-82.2,117.936a4.7,4.7,0,0,0,.987,3.885,4.7,4.7,0,0,0,3.626,1.709H-52.92a4.7,4.7,0,0,0,4.612-3.8L-36.34,58.143H-20.5c7.332,0,8.871,1.566,8.933,1.633.445.478,1.03,2.695.064,7.659l-9.813,50.5a4.7,4.7,0,0,0,.987,3.885A4.7,4.7,0,0,0-16.7,123.53H8.356a4.7,4.7,0,0,0,4.612-3.8l10.32-53.112c2.422-12.467.35-21.82-6.156-27.8-6.208-5.7-16.608-8.473-31.792-8.473H-30.935L-26.124,5.6a4.7,4.7,0,0,0-.987-3.885A4.7,4.7,0,0,0-30.737,0m0,4.7-5.9,30.344h21.975q20.74,0,28.613,7.234t4.724,23.444L8.356,118.832H-16.7l9.813-50.5q1.675-8.617-1.233-11.752T-20.5,53.445H-40.214L-52.92,118.832H-77.587L-55.4,4.7h24.667",
    transform: "translate(82.285)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3500",
    transform: "translate(196.408 32.694)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3502",
    d: "M-30.846-39.222c9.448,0,16.5-1.742,20.964-5.177,4.415-3.4,7.464-9.288,9.063-17.5C.671-69.581.1-74.943-2.506-77.837c-2.668-2.955-8.436-4.454-17.144-4.454h-15.1l-8.37,43.069ZM-80.228,13.832a2.346,2.346,0,0,1-1.812-.855,2.348,2.348,0,0,1-.494-1.942L-60.351-103.1a2.35,2.35,0,0,1,2.307-1.9h47.809c15.026,0,26.21,4.08,33.24,12.128,7.067,8.089,9.249,19.4,6.486,33.61A53.691,53.691,0,0,1,23.742-43.28a53.512,53.512,0,0,1-10.58,13.257A46.415,46.415,0,0,1-4.251-19.589c-6.267,2.041-14.315,3.077-23.921,3.077h-19.36l-5.526,28.443a2.35,2.35,0,0,1-2.307,1.9Z",
    transform: "translate(82.578 105)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3504",
    transform: "translate(194.059 30.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3506",
    d: "M-31.074-16.342h13.162c10.51,0,14.16,2.306,15.4,3.68C-.452-10.38-.064-5.569-1.387,1.25-2.874,8.886-5.629,14.3-9.577,17.339c-4.042,3.112-10.614,4.689-19.531,4.689H-38.53ZM-8.5-43.75h-47.81a4.7,4.7,0,0,0-4.612,3.8L-83.1,74.186a4.7,4.7,0,0,0,.986,3.885A4.7,4.7,0,0,0-78.49,79.78h24.863a4.7,4.7,0,0,0,4.612-3.8l5.158-26.542h17.423c9.853,0,18.147-1.074,24.65-3.193a48.761,48.761,0,0,0,18.29-10.952A55.856,55.856,0,0,0,27.53,21.466a55.991,55.991,0,0,0,6-16.681c2.909-14.961.546-26.94-7.023-35.6C19.016-39.4,7.237-43.75-8.5-43.75M-44.23,26.727h15.123q15.036,0,22.4-5.665T3.225,2.145Q5.694-10.578.977-15.81t-18.889-5.231H-34.947L-44.23,26.727M-8.5-39.052q21.574,0,31.47,11.324T28.922,3.889a51.1,51.1,0,0,1-5.493,15.285A50.971,50.971,0,0,1,13.31,31.847,43.914,43.914,0,0,1-3.239,41.776q-9.1,2.966-23.2,2.962h-21.3l-5.9,30.344H-78.49L-56.307-39.052H-8.5",
    transform: "translate(83.188 43.75)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhp);
export default __webpack_public_path__ + "static/media/php.c3774650da40c0f75e43eab3b915ab3c.svg";
export { ForwardRef as ReactComponent };